var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleLeftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8162D24C-8BB7-4657-8888-09139BED6783") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stylesheet",
    transform: "translate(-205.000000, -831.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(205.000000, 831.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E6E6E6",
    fill: "#FFFFFF",
    cx: 25,
    cy: 25,
    r: 24.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.720517,30 C25.0694669,30 25.4184168,29.8836834 25.6510501,29.6510501 L32.0484653,23.2536349 C32.2810985,23.0210016 32.3974152,22.6720517 32.3974152,22.3231018 C32.3974152,21.9741519 32.2810985,21.6252019 32.0484653,21.3925687 C31.815832,21.1599354 31.4668821,21.0436187 31.1179321,21.0436187 C30.7689822,21.0436187 30.4200323,21.1599354 30.187399,21.3925687 L24.720517,26.8594507 L19.2536349,21.3925687 L19.2536349,21.3925687 C18.904685,21.0436187 18.4394184,20.9273021 17.9741519,21.0436187 C17.5088853,21.1599354 17.1599354,21.5088853 17.0436187,21.9741519 C16.9273021,22.4394184 17.0436187,22.904685 17.3925687,23.2536349 L23.7899838,29.6510501 C24.0226171,29.8836834 24.371567,30 24.720517,30 L24.720517,30 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.504661923,
    transform: "translate(24.698708, 25.500000) scale(-1, 1) rotate(-90.000000) translate(-24.698708, -25.500000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLeftIcon);
export default __webpack_public_path__ + "static/media/circle-left-icon.1c6fa48535578a9a17187e90cc25075a.svg";
export { ForwardRef as ReactComponent };